import React, { useEffect } from "react";
import { Container, } from "react-bootstrap";
import { connect } from "react-redux";
import { baseURL, headers } from "../../../../../global/api";
import { setHeading } from "../../../accounts/account.actions";
import { getRecipeData } from "./Recipe.action";
import MaterialTable from "material-table";


const ViewRecipe = (props) => {

  useEffect(() => {
    props.setHeading("Recipe List");
  }, []);

  return (
    <>
      <Container fluid>
        <MaterialTable
          title="Recipe Details"
          columns={[
            // { title: 'Product Id', field: 'product_id', editable: 'never' },
            { title: "Product Name", field: "productName", editable: 'never' },
            { title: "Variation Name", field: "productVariationName", editable: 'never' },
            { title: "Product Date", field: "productDate", editable: 'never' },
            // { title: "Product Description", field: "desc", },
          ]}
          data={(query) =>
            new Promise((resolve, reject) => {
              let url = `${baseURL}/recipe?`;
              url += "limit=" + query.pageSize;
              url += "&page=" + (query.page);
              url += "&search=" + query.search;
              fetch(url, {
                method: 'GET',
                headers: headers,
              }).then((response) => response.json()).then((result) => {
                resolve({
                  data: result.data,
                  page: result.page,
                  totalCount: result.total_results,
                });
              });
            })
          }
          detailPanel={rowData => {
            return (
              <MaterialTable
                columns={[
                  { title: 'Recipe Product ', field: 'recipeProductName' },
                  { title: 'Quantity', field: 'quantity' },
                  { title: 'UOM', field: 'uomName' },
                  { title: 'Price', field: 'price' },
                ]}
                data={rowData.recipeProducts}
                options={{
                  actionsColumnIndex: -1,
                  toolbar: false,
                  exportButton: true,
                  sorting: true,
                  paging: true,
                  pageSize: 200,
                  emptyRowsWhenPaging: false,
                  pageSizeOptions: [50, 100, 150, 200],
                  headerStyle: {
                    position: 'sticky', top: 0,
                    color: '#00BBBB',
                    fontWeight: '550',
                    onRowAdd: 'none',
                  }
                }}
              />
            )
          }}
          options={{
            actionsColumnIndex: -1,
            exportButton: true,
            exportAllData: true,
            paging: true,
            pageSize: 50,
            emptyRowsWhenPaging: false,
            pageSizeOptions: [30, 50, 100, 150, 200],
            headerStyle: {
              position: "sticky",
              top: 0,
              color: "#00BBBB",
              fontWeight: "550",
              onRowAdd: "none",
            },
          }}
        />
      </Container>
    </>
  );
};
const mapDispatchToProps = (dispatch) => {
  return {
    getRecipe: () => dispatch(getRecipeData()),
    setHeading: (data) => dispatch(setHeading(data)),
  };
};
const mapStateToProps = (state, ownProps) => ({
  recipeList: state.RecipeReducer.recipeList,
  isFetchingRecipe: state.RecipeReducer.isFetchingRecipe,
});

export default connect(mapStateToProps, mapDispatchToProps)(ViewRecipe);
